// The roles a team member can have (the server's own list is in netlify/lib/auth.mjs)
export const ROLES = ['Admin', 'PM', 'Finance', 'Read-only', 'Freelancer'];
